<template>
	<div class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="title">{{$t('pages.info.breadcrumb')}}</div>
			<div class="card">
				<div class="cardLeft">
					<div class="infoTitle">{{articleInfo.title}}</div>
					<div class="infoDate">
						<div>{{$t('pages.info.published')}}{{articleInfo.gmt_create}}</div>
						<div>{{$t('pages.info.views', {count: articleInfo.click_count})}}</div>
					</div>
					<div class="middleText">{{articleInfo.short_intro}}</div>
					<div class="text"><div v-html="articleInfo.content"></div>
					</div>
				</div>
				<div class="cardRight">
					<div class="hotTitle">{{$t('pages.info.hot_recommend')}}</div>
					<div class="hotList">
						<div class="hotLi" v-for="(item, index) in latestArtList" :key="item.id" :class="{active: item.id== id}">
							<router-link  :to="{path:'/info',query:{id:item.id}}"> 
								{{item.title}}
							</router-link>
						</div>
					</div>
				</div>
			</div>
			
			<div class="pagniationArea">
				<div class="pagLayout" v-if="previous == null">
				</div>
				<div class="pagLayout" v-else>
					<router-link  :to="{path:'/info',query:{id:previous.id}}"> 
						<div class="pageText1 left">{{$t('pages.info.previous')}}</div>
						<div  class="pageText2 left">{{previous.title}}</div>
					</router-link>
				</div>
				<div class="pagLayout" v-if="next == null">
				</div>
				<div class="pagLayout" v-else>
					<router-link  :to="{path:'/info',query:{id:next.id}}"> 
						<div class="pageText1 right">{{$t('pages.info.next')}}</div>
						<div  class="pageText2 right">{{next.title}}</div>
					</router-link>
				</div>
			</div>
		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	export default{
		components:{
			Head2,
			Foot2,
		},
		data(){
			return {
				id:0,
				index: 0,
				articleInfo: {},
				latestArtList:[],
				previous:{},
				next:{},
				flag:false
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.GetArticleInfo();
			//this.getLatestArticleInfo();

		},
		methods:{
			GetArticleInfo() {
				this.articleInfo={};
				this.$scUtil.axiosPost(this, 'ArticleApi/GetArticleInfo', {
					id: this.id
				}, res => {
					console.log("获取文章内容:" + res.code);
					if (res.code == 100) {
						this.articleInfo = res.data;	
						this.getLatestArticleInfo();
					}
			
				});
			},
			getLatestArticleInfo() {
				this.$scUtil.axiosPost(this, 'ArticleApi/GetArticleListByType', {
					articleType: this.articleInfo.type_name,
					count: 15
				}, res => {
					if (res.code == 100) {
						res.data.forEach(item => {
						    item.gmt_create=this.$scUtil.dateFormatter(new Date(item.gmt_create), 'Y/M/D');
						});
						this.latestArtList = res.data;
						this.index = this.latestArtList.findIndex(item => item.id === this.id);
						if(this.index === 0){
								// 提示已经是第一篇或者禁用上一篇按钮 自由发挥咯
						} 
						else {
							this.previous = this.latestArtList[this.index-1] // 获取上一篇id 在getList()里需要
						}
						this.index = this.latestArtList.findIndex(item => item.id === this.id);
						if(this.index >=  this.latestArtList.length-1){
								// 提示已经是最后一篇或者禁用下一篇按钮 自由发挥咯
						} else {
								this.next = this.latestArtList[this.index+1] // 获取上一篇id 在getList()里需要
						}
					}

				});
			},
		}
		
	}
</script>

<style scoped>
	.pageArea{
		background-color: #ebecee;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.mainAea{
		width: 1200px;
	}
	
	.title{
		font-size: 13px;
		color: #333333;
		height: 37px;
		line-height: 37px;
	}
	
	.card{
		width: 1200px;
		background-color: #fff;
		padding: 26px 36px;
		display: flex;
		box-sizing: border-box;
	}
	
	.cardLeft{
		flex: 1;
	}
	
	.cardRight{
		width: 282px;
		border: 1px solid #e2e2e2;
		margin-left: 20px;
	}
	
	.hotTitle{
		font-size: 16px;
		color: #000;
		height: 56px;
		line-height: 56px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 24px;
		font-weight: bolder;
	}
	
	.hotList{
		padding: 10px 0;
	}
	
	.hotLi{
		font-size: 14px;
		width: 282px;
		box-sizing: border-box;
		color: #686868;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		padding:10px 27px;
	}
	
	.hotLi:hover,.hotLi.active{
		color: #0380fe;
	}
	
	.infoTitle{
		font-size: 22px;
		color: #000000;
		font-weight: bolder;
		text-align: left;
		width:100%;
		margin-top: 10px;
	}
	
	.infoDate{
		display: flex;
		width: 100%;
		justify-content: space-between;
		font-size: 14px;
		color: #666666;
		height:59px;
		line-height: 59px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.middleText{
		width: 100%;
		text-align: center;
		margin-top: 40px;
		font-size: 24px;
		color: #333333;
		font-weight: bolder;
	}
	
	.text{
		width: 100%;
		font-size: 15px;
		color: #000000;
		line-height: 35px;
		margin-top: 30px;
		text-indent: 30px;
	}
	
	.infoImg{
		text-align: center;
	}
	
	.pagniationArea{
		width: 1200px;
		display: flex;
		align-items: center;
		margin-top: 22px;
		margin-bottom: 20px;
	}
	
	.pagLayout{
		width: 589px;
		background-color: #fff;
		margin-right: 22px;
		height: 97px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 27px;
		cursor: pointer;
	}
	
	.pagLayout:nth-last-child(1){
		margin-right: 0px;
	}
	
	.pageText1{
		font-size: 15px;
		color:#666666
	}
	
	.pageText2{
		font-size: 15px;
		color: #000;
		line-height: 40px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 535px;
	}
	
	.left{
		text-align: left;
	}
	
	.right{
		text-align: right;
	}
</style>